import styled, { css } from 'styled-components';

import { Box, system, SystemProps } from '@sternum/styled-system';

export const AnimationBox = styled(Box)<SystemProps>`
  width: min-content;
  height: min-content;
  transition-duration: 0.2s;

  ${(props) => {
    return css`
      ${!props.rotate
        ? ''
        : css`
            rotate: ${props.rotate};
          `}
    `;
  }}

  ${system}
`;

export const AnimationFlexBox = styled(AnimationBox)<SystemProps>`
  display: flex;

  ${system}
`;
